import { Component, input } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardSubtitle } from '@angular/material/card';
import { TranslocoModule } from '@jsverse/transloco';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { TextInputComponent } from '@app/calculators/components/text-input/text-input.component';
import { AppValidationMessageDirective } from '@app/calculators/effort-planner-form/form-validation/validationMessage';
import { AsyncPipe } from '@angular/common';
import { BillingContactModel } from '../models/billingContactModel';

@Component({
  selector: 'app-billing-information-form',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatCardSubtitle,
    TranslocoModule,
    MatInputModule,
    ReactiveFormsModule,
    TextInputComponent,
    AppValidationMessageDirective,
    AsyncPipe,
  ],
  templateUrl: './billing-information-form.component.html',
})
export class BillingInformationFormComponent {
  readonly billingContact = input.required<BillingContactModel>();
  readonly disabled = input(false);
}
